import { jsx as _jsx } from "react/jsx-runtime";
import { MedosThemeProvider } from "../react/ThemeProvider";
import { UnifiedBookingWidget } from "../components/unified/UnifiedBookingWidget";
import { BaseWidget } from "./shared/BaseWidget";
import { resolveWidgetTheme } from "./shared/resolveWidgetTheme";
import { resolveWidgetLayout } from "../utils/widgetLayout";
import { resolveOtpChannels } from "../utils/resolveOtpChannels";
class MedosUnifiedWidget extends BaseWidget {
    getModalId() {
        return "medos-unified-modal";
    }
    getWidgetContentId() {
        return "medos-unified-widget-content";
    }
    renderComponent() {
        if (!this.root || !this.config)
            return;
        const handleSuccess = (data) => {
            this.config?.onSuccess?.(data);
            if (this.isModalMode) {
                setTimeout(() => this.close(), 3000);
            }
        };
        const handleError = (error) => {
            this.config?.onError?.(error);
        };
        this.root.render(_jsx(MedosThemeProvider, { theme: resolveWidgetTheme(this.config), children: _jsx(UnifiedBookingWidget, { calendarOnly: this.config.calendarOnly, compact: this.config.compact, layout: resolveWidgetLayout(this.config.layout), otpChannels: resolveOtpChannels(this.config.otpChannels), maxWidth: this.config.maxWidth, maxHeight: this.config.maxHeight, onSuccess: handleSuccess, onError: handleError }) }));
    }
}
const widgetInstance = new MedosUnifiedWidget();
window.MedosBooking = {
    init: (config) => widgetInstance.init(config),
    open: (config) => widgetInstance.open(config),
    close: () => widgetInstance.close(),
};
export default widgetInstance;
